import React from 'react';

export function ChartSkeleton({ bars = 8 }) {
  const heights = React.useMemo(
    () => Array.from({ length: bars }, (_, i) => 30 + ((i * 37) % 65)),
    [bars],
  );
  return (
    <div className="dx-skel-card">
      <div className="dx-skel-head">
        <div className="dx-skel b1" />
        <div className="dx-skel b2" />
      </div>
      <div className="dx-skel-chart">
        <div className="axis-y" />
        <div className="axis-x" />
        <div className="bars">
          {heights.map((h, i) => <div key={i} style={{ height: `${h}%` }} />)}
        </div>
      </div>
    </div>
  );
}

export function TableSkeleton({ rows = 6 }) {
  return (
    <div className="dx-skel-table">
      {Array.from({ length: rows }).map((_, i) => (
        <div className="row" key={i}>
          <div /><div /><div /><div />
        </div>
      ))}
    </div>
  );
}

export function MetricSkeleton() {
  return (
    <div className="dx-skel-metric">
      <div className="dx-skel v" />
      <div className="dx-skel l" />
    </div>
  );
}

export default function Skeleton({ kind = 'chart' }) {
  if (kind === 'table')  return <TableSkeleton />;
  if (kind === 'metric') return <MetricSkeleton />;
  return <ChartSkeleton />;
}
